export default "__VITE_ASSET__CRhaDZlQ__"